<template>
    <div class="index">
        <van-nav-bar
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
        />
        <div class="carList"  v-for="(item,key) in car" :key="key" @click="sheetShow">
            <div class="imgBox"><img src="../../../static/images/icon_washcard.png" alt=""></div>
            <div class="content">
                <div class="num">{{item.carNum}}</div>
                <div class="money">卡余额：{{item.carMoney}}</div>
            </div>
            <div class="type" :style="item.carState==1?'color: #76cabc;':'color:red;'">{{carStareArr[item.carState]}}</div>
        </div>
        <!-- 换卡  退卡-->
        <van-action-sheet
        v-model="show"
        :actions="actions"
        cancel-text="取消"
        close-on-click-action
        @cancel="show = false"
         @select="oncheck"
        />
       
    </div>
</template>

<script>
 export default {
  data() {
    return {
        title:'我的卡包',
        // 无 我的卡片  ， tyoe 1 退卡 换卡
        type:0,
        carStareArr:['已失效','正常'],
        car:[
            {
                carNum:'M9939999',
                carMoney:'111.00',
                carState:1,
            },
            {
                carNum:'M999499999',
                carMoney:'222.00',
                carState:0,
            },
            {
                carNum:'M999959999',
                carMoney:'333.00',
                carState:1,
            },
            {
                carNum:'M999996999',
                carMoney:'444.00',
                carState:0,
            },
            {
                carNum:'M999979999',
                carMoney:'555.00',
                carState:1,
            },
            
        ],
        show:false,
        actions: [{name: '换卡'}, {name: '退卡'}],

    };
  },
   created() {
       if (this.$route.query.type) {
           this.type = this.$route.query.type
           this.title = '退卡换卡'
       }
    },
  mounted(){
    
  },
  methods: {
    oncheck(item){
        console.log(item);
        if (item.name=='换卡') {
            this.$router.push({path:'/washingMachine/carChange'})
        }else if(item.name=='退卡'){
            this.$router.push({path:'/washingMachine/carOut'})
        }
    },
    sheetShow(){
        if (this.type == 1) {
            this.show = true
        }
    },
     jump(imgUrl,key){
          this.$router.push({path:imgUrl})
      
      },
    //   后退
    onClickLeft(){
        this.$router.go(-1)
    }
  },
}
</script>
<style lang="less" scoped>
.index{
    width: 100%;
    height: 100%;
 .carList{
     height: 4rem;
     margin: 1rem 0.5rem;
     border-radius: 0.5rem;
     display: flex;
     justify-content: left;
      box-shadow: 0px 0px 10px #bbb;
      background-color: #fff;
     .imgBox{
         width: 4rem;
         img{
             width: 2.8rem;
             height: 2.8rem;
             margin: 0.5rem 0.5rem;
         }
     }
     .content{
        width: 7rem;
        margin-top: 0.8rem;
        text-align: left;
        margin-left: 0.5rem;
        .num{
              line-height: 1rem;
            font-size: 0.6rem;
        }
        .money{
            line-height: 1.5rem;
            font-size: 0.5rem;
            color: #d38545;
        }
     }
     .type{
         line-height: 4rem;
        
     }
 }
}
</style>



// WEBPACK FOOTER //
// src/pages/washingMachine/washercard.vue